import { LoginButton, TelegramAuthData } from "@telegram-auth/react"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { showToast } from "@/helpers/toast"
import { useAppSelector } from "@/store"
import { useWebAuthMutation } from "@/store/apis/authAPI/auth.api"
import { AppSelectors } from "@/store/slices/app"
import type { IAuthMode } from "../types"
import styles from "./TelegramAuthButton.module.scss"

interface ITelegramAuthButton {
  mode: IAuthMode
}

export const TelegramAuthButton: FC<ITelegramAuthButton> = ({ mode }) => {
  const { t } = useTranslation()
  const language = useAppSelector(AppSelectors.selectLanguage())

  const [webAuth] = useWebAuthMutation()

  const i18nPrefix = mode === "login" ? "login" : "register"

  const onAuthCallback = async (data: TelegramAuthData) => {
    try {
      await webAuth({
        id: data.id,
        first_name: data.first_name,
        username: data.username ?? "",
        photo_url: data.photo_url ?? "",
        auth_date: data.auth_date,
        hash: data.hash
      }).unwrap()
    } catch {
      showToast.error(t("errors.authFailed"))
    }
  }

  return (
    <div
      className={styles.TelegramAuthButton}
      aria-label={t(`${i18nPrefix}.telegram`)}
    >
      <LoginButton
        botUsername={import.meta.env.VITE_BOTNAME}
        buttonSize="large"
        cornerRadius={20}
        showAvatar
        lang={language}
        onAuthCallback={onAuthCallback}
      />
    </div>
  )
}
